module.exports = __webpack_public_path__ + "img/logo_eee_4c_r.37bee6c4.png";